'use strict';

const get = require('lodash/get');

const RADIUS_IN_METERS = 3000;

module.exports = (function() {
  class NearbyDeals {
    static initClass() {
      this.prototype.rootUrl = '/merchant-page';
      this.prototype.templates = {
        dealCard: require('../../deals/deal_card.html.mustache'),
      };
    }

    constructor({ $el, place, limit }) {
      this.$el = $el;
      this.place = place;
      this.limit = limit;
      this.fetchAndRender();
    }

    fetchAndRender(withCategories = true) {
      const data = {
        lat: this.place.location.lonLat.lat,
        lon: this.place.location.lonLat.lon,
        limit: this.limit,
        radius: RADIUS_IN_METERS,
      };

      if (withCategories === true) {
        data.categories = this.getCategories();
      }

      const request = $.get(`${this.rootUrl}/offers-map/places`, data, res => {
        // Check if the drawer was closed before trying to insert new HTML in it.
        if (!this.isElementInDom()) {
          return null;
        }

        const deals = this.getDeals(get(res, 'data.places', undefined)); // If we get no deals in the response, we try again but with no categories.

        if (
          withCategories === true &&
          !((deals != null ? deals.length : undefined) > 0)
        ) {
          return this.fetchAndRender(false);
        } // Completely hide the widget if there are no deals.

        if (!((deals != null ? deals.length : undefined) > 0)) {
          return this.hide();
        }

        return this.render(res.data.places);
      });
      return request.fail(() => {
        if (!this.isElementInDom()) {
          return;
        }

        return void this.hide();
      });
    }

    getCategories() {
      if (
        !(
          (this.place.categories != null
            ? this.place.categories.length
            : undefined) > 0
        )
      ) {
        return null;
      }

      const categories = [];

      for (const category of this.place.categories) {
        if (!categories.includes(category.uuid)) {
          categories.push(category.uuid);
        }

        if (category.root != null && !categories.includes(category.root.uuid)) {
          categories.push(category.root.uuid);
        }
      }

      return categories.join(',');
    }

    isElementInDom() {
      return $.contains(document, this.$el[0]);
    }

    hide() {
      return this.$el.hide();
    }

    getDeals(places) {
      if (!((places != null ? places.length : undefined) > 0)) {
        return null;
      }

      const deals = [];

      for (const place of places) {
        const items = get(place, 'offers.deal.items', undefined);

        if ((items != null ? items[0] : undefined) != null) {
          deals.push(items[0]);
        }
      }

      return deals;
    }

    render(places) {
      const deals = this.getDeals(places);

      if (!((deals != null ? deals.length : undefined) > 0)) {
        return this.hide();
      }

      let dealsHtml = '';

      for (const deal of deals) {
        deal.forceMobileStyles = true;

        deal.translate = deal.t = () => str => I18n.t(str);

        dealsHtml += this.templates.dealCard.render(deal);
      }

      return this.$el.find('.deals').html(dealsHtml);
    }
  }
  NearbyDeals.initClass();
  return NearbyDeals;
})();
